import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { HeaderActionList, Logout, useAuth } from '@bento-dental/core';
import { useStorageKey } from '@bento-dental/core/hooks';
import ChatPopup from '../Assistant/ChatPopup';

function HeaderView() {
  const { logout } = useAuth();
  const username = useStorageKey<string>('username');
  const role = useStorageKey<string>('role');
  const [assistantOpen, setAssistantOpen] = useState(false);

  return (
    <>
      <ChatPopup open={assistantOpen} onClose={() => setAssistantOpen(false)} />
      <Box display="flex">
        <Stack spacing={0} paddingY={0} paddingX={2} flexGrow={1}>
          <Typography color="textPrimary" fontFamily="inherit" fontWeight={600} fontSize="inherit">
            Admin portal
          </Typography>
          <Typography fontFamily="inherit" variant="subtitle1">
            {role}
          </Typography>
        </Stack>
        <Box display="flex" alignItems="center" gap={2} marginRight={2}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<AutoAwesomeIcon />}
            sx={{ pointerEvents: 'auto', textTransform: 'none', whiteSpace: 'nowrap' }}
            onClick={() => setAssistantOpen(true)}
          >
            Ask Bento Assistant
          </Button>
        </Box>
        <HeaderActionList>
          <Typography fontFamily="inherit" fontSize="inherit">
            {username}
          </Typography>
          <Logout logout={logout} />
        </HeaderActionList>
      </Box>
    </>
  );
}

export default HeaderView;
